export default __webpack_public_path__ + "static/media/hkkba.a5552359.png";